import React, { useEffect, useContext } from 'react'
import { useLazyQuery, NetworkStatus } from '@apollo/client'
import { TableRow } from '@material-ui/core'
import { isEmpty } from 'lodash'
import moment from 'moment'
import { DailyMonitoringDetailsFiltersContext } from '../../../../../../context/DailyMonitoringDetailsFiltersContext'
import EmptyCells from '../../../../../../components/EmptyCells'
import DefaultTableCellSmallSpace from '../../../../../../components/DefaultTableCellSmallSpace'
import { GET_ORDERS_TOTAL_HISTORY } from '../../../../../../queries/dailyMonitoring'
import { GET_ORDERS_CANCELLED_TOTAL_HISTORY } from '../../../../../../queries/dailyMonitoringCancelled'
import { formatNumber, getDaysInMonth, DaysInMonth } from '../../../../../../utils/Helpers'
import { defaultFormatMonthTimeZone } from '../../../../../../utils/consts'

const title = '% de cancelemanto GMV'
export default function DailyOrdersPercentageHistory (): JSX.Element {
  const { filters } = useContext(DailyMonitoringDetailsFiltersContext)
  const [getData, { loading, error, data, networkStatus }] = useLazyQuery(
    GET_ORDERS_TOTAL_HISTORY, {
      notifyOnNetworkStatusChange: true
    }
  )
  const [getDataCancelled, { loading: loadingCancelled, error: errorCancelled, data: dataCancelled }] = useLazyQuery(
    GET_ORDERS_CANCELLED_TOTAL_HISTORY, {
      notifyOnNetworkStatusChange: true
    }
  )

  useEffect(() => {
    const createdAt: any = {
      initialDate: `${filters.date.year}-${filters.date.month}||/M`,
      finalDate: `${filters.date.year}-${filters.date.month}||/M`,
      ...defaultFormatMonthTimeZone
    }

    getData({
      variables: { filters: { states: filters.states, cities: filters.cities, createdAt } }
    })
    getDataCancelled({
      variables: { filters: { states: filters.states, cities: filters.cities, createdAt } }
    })
  }, [filters])

  if (networkStatus === NetworkStatus.refetch) return <EmptyCells title={title} />
  if (loading || !data || loadingCancelled || !dataCancelled) return <EmptyCells title={title} />
  if (error || errorCancelled) return <EmptyCells title={title} />
  if (!data.ordersAggs?.aggregations?.salesOverTime || !dataCancelled.ordersAggs?.aggregations?.salesOverTime) return <EmptyCells title={title} />

  const { buckets } = data.ordersAggs?.aggregations?.salesOverTime
  const { buckets: bucketsCancelled } = dataCancelled.ordersAggs?.aggregations?.salesOverTime

  const newData: any = []
  buckets.map((bucket: any) => {
    const ordersTotal = bucket.delivered.total.value
    const ordersCancelledTotal = bucketsCancelled.filter((bucketCancelled: any) => { return bucketCancelled.key_as_string === bucket.key_as_string })[0]
    if (ordersCancelledTotal) {
      newData.push({
        key_as_string: bucket.key_as_string,
        value: (ordersCancelledTotal.total.value * 100) / (ordersTotal + ordersCancelledTotal.total.value)
      })
    }
  })

  return (
    <TableRow>
      <DefaultTableCellSmallSpace style={{ fontSize: 12 }}>{title}</DefaultTableCellSmallSpace>
      {getDaysInMonth(filters.date.year, filters.date.month).map((day: DaysInMonth) => {
        const bucket = newData.filter((b: any) => moment.parseZone(String(b.key_as_string)).isSame(moment(day.date, 'DD/MMM/YYYY'), 'day'))[0]
        return !isEmpty(bucket) ? <DefaultTableCellSmallSpace style={{ fontSize: 12 }} key={bucket.key_as_string}>{`${formatNumber(bucket.value, 2)}%`}</DefaultTableCellSmallSpace> : <DefaultTableCellSmallSpace>-</DefaultTableCellSmallSpace>
      })}
    </TableRow>
  )
}
